import { render, staticRenderFns } from "./POIManagerEdit.vue?vue&type=template&id=bdf15be0&"
import script from "./POIManagerEdit.vue?vue&type=script&lang=js&"
export * from "./POIManagerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports